import { useContext } from "react";
import { ImagePreviewContext } from "../providers/ImagePreviewProvider";

export default function useImagePreview() {
    return useContext(ImagePreviewContext);
}